<template>
  <div>
    <span class="progress-step-type"><b>Steps:</b></span>
    <span class="step-indicator"
      ><b>{{ numberOfCompletedSteps }} of {{ numberOfSteps }}</b></span
    >
    <v-progress-linear
      v-model="valueDeterminate"
      :indeterminate="loading"
      color="primary"
      height="5"
      background-color="grey"
    />
    <div class="text-center mt-6">
      <div v-if="testator.hasActivePayment">
        <p
          v-if="showFreeDownloadInsuranceText"
          class="text-center font-weight-bold"
        >
          With your active {{ whitelabel.insurancePolicyName }} you get free
          will updates <a>plus more</a>
        </p>
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <DownloadWill
              :disabled="downloadDisabled"
              :testator="testator"
              :call-to-action="callToAction"
              :willDetailsChanged.sync="willDetailsChanged"
              @willDownloaded="$emit('willDownloaded')"
            />
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <PreviewWill
              :disabled="downloadDisabled"
              :testator="testator"
              :call-to-action="callToActionPreview"
              :previewWillDetailsChanged.sync="previewWillDetailsChanged"
              @previewWillDownloaded="$emit('previewWillDownloaded')"
            />
          </v-col>
        </v-row>
      </div>
      <v-btn
        v-else
        rounded
        depressed
        :outlined="!callToAction"
        large
        :disabled="numberOfCompletedSteps != numberOfSteps"
        color="primary"
        to="/payment-plan"
      >
        <span>{{ payAndDownloadBtnText }}</span
        ><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
  import DownloadWill from '../common/DownloadWill';
  import PreviewWill from '../common/PreviewWill';
  import Revise from '../../helpers/reviseStep';

  export default {
    name: 'OverviewProgressBars',
    components: {
      DownloadWill,
      PreviewWill,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
      steps: {
        required: true,
        type: Array,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      willDetailsChanged: {
        type: Boolean,
      },
      previewWillDetailsChanged: {
        type: Boolean,
      },
    },
    computed: {
      downloadDisabled() {
        if (this.hasStepToRevise) {
          return true;
        } else {
          return this.numberOfCompletedSteps != this.numberOfSteps;
        }
      },
      hasStepToRevise() {
        return Revise.anyStepsToRevise(this.testator);
      },
      numberOfSteps() {
        return this.steps.length;
      },
      numberOfCompletedSteps() {
        return this.steps.filter(s => s.completed == true).length;
      },
      valueDeterminate() {
        return (this.numberOfCompletedSteps / this.numberOfSteps) * 100;
      },
      callToAction() {
        return !this.testator.willVersions.length || this.willDetailsChanged;
      },
      callToActionPreview() {
        return (
          !this.testator.previewWillVersions.length ||
          this.previewWillDetailsChanged
        );
      },
      showFreeDownloadInsuranceText() {
        return (
          this.testator.insurance && this.testator.insurance.rootPolicyNumber
        );
      },
      payAndDownloadBtnText() {
        return this.testator.isEntitledToFirstWillFree
          ? 'Choose plan & download will'
          : 'Pay & download will';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .step-indicator {
    float: right;
    font-size: 16px;
  }

  .progress-step-type {
    font-size: 18px;
  }
</style>
